import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './organization-workflow.reducer';

export const OrganizationWorkflowDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const organizationWorkflowEntity = useAppSelector(state => state.organizationWorkflow.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="organizationWorkflowDetailsHeading">
          <Translate contentKey="tycheApp.organizationWorkflow.detail.title">OrganizationWorkflow</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{organizationWorkflowEntity.id}</dd>
          <dt>
            <span id="key">
              <Translate contentKey="tycheApp.organizationWorkflow.key">Key</Translate>
            </span>
          </dt>
          <dd>{organizationWorkflowEntity.key}</dd>
          <dt>
            <span id="flowUrl">
              <Translate contentKey="tycheApp.organizationWorkflow.flowUrl">Flow Url</Translate>
            </span>
          </dt>
          <dd>{organizationWorkflowEntity.flowUrl}</dd>
          <dt>
            <span id="flowContent">
              <Translate contentKey="tycheApp.organizationWorkflow.flowContent">Flow Content</Translate>
            </span>
          </dt>
          <dd>{organizationWorkflowEntity.flowContent}</dd>
          <dt>
            <Translate contentKey="tycheApp.organizationWorkflow.organization">Organization</Translate>
          </dt>
          <dd>{organizationWorkflowEntity.organization ? organizationWorkflowEntity.organization.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/organization-workflow" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/organization-workflow/${organizationWorkflowEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default OrganizationWorkflowDetail;
